<template>
  <v-container>
    <div id="principaisClientes">
      <div
        v-if="loading"
        :style="styleObject"
        class="text-center"
      >
        <v-icon
          light
          class="custom-loader"
          :style="styleObject"
        >
          mdi-cached
        </v-icon>
        Carregando dados...
      </div>
      <div
        v-else-if="error"
        class="alert alert-danger"
      >
        {{ error }}
      </div>
      <div
        v-else
      >
        <div
          id="idTable"
          style="overflow-x: auto; max-width: 100%;"
        >
          <table
            style="width: 100%; table-layout: fixed; color: black; border-collapse: collapse;"
            class="elevation-1"
          >
            <thead>
              <tr>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                  class="black--text title"
                >
                  Cliente
                </th>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                  class="black--text title"
                >
                  Volume (L)
                </th>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                  class="black--text title"
                >
                  Faturamento
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="item in faturamentoPrincipaisClientes"
                :key="item.id"
              >
                <td
                  id="dadoMovimentacao"
                  style="text-align: left;"
                >
                  {{ item.nome_cliente }}
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: right;"
                >
                  {{ item.quantidade }}
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: right;"
                >
                  {{ item.faturamento }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <router-link
          to="/vendas/detalhe-principais-clientes"
          :style="styleObject"
          class="text-center"
        >
          <div
            id="linkDetalhePrincipaisClientes"
            class="text-center"
          >
            <v-icon
              id="iconLinkPrincipaisClientes"
              class="text-center"
            >
              mdi-chevron-double-down
            </v-icon><br>
          </div>
        </router-link>
      </div>
    </div>
  </v-container>
</template>

<script>
  import Cliente from '../../../../../services/somentecliente4'
  import eventEmit from '../../core/EventoEmit'

  export default {
    name: 'ShowFaturamentoVendas',
    emits: [],
    components: {
    },
    data: () => ({
      styleObject: {
        color: localStorage.corPrimaria,
      },
      loading: false,
      error: null,
      primeiroDia: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      date: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      select: [],
      supervisor: [],
      vendedor: [],
      area: [],
      rede: [],
      receita: [],
      segmento: [],
      categoria: [],
      promotor: [],
      classificacao: [],
      linhaProducao: [],
      cidades: [],
      enableFatPrinCliente: false,
      headersPrinCliente: [
        { text: 'Cliente', value: 'nome_cliente', width: '50%', class: 'black--text title' },
        { text: 'Quantidade (kg)', value: 'quantidade', width: '25%', align: 'right', class: 'black--text title' },
        { text: 'Faturamento', value: 'faturamento', width: '25%', align: 'right', class: 'black--text title' },
      ],
      faturamentoPrincipaisClientes: [],
    }),

    created () {
      eventEmit.$on('set_faturamento_novos_clientes', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('set_faturamento_novos_clientes', this.handleUpdateDados)
    },

    methods: {
      handleUpdateDados (primeiroDia, dataFinal, select, vendedor, area, rede, supervisor, receita, segmento, categoria, promotor, classificacao, linhaProducao, cidades) {
        this.primeiroDia = primeiroDia
        this.date = dataFinal
        this.select = select
        this.supervisor = supervisor
        this.vendedor = vendedor
        this.area = area
        this.rede = rede
        this.receita = receita
        this.segmento = segmento
        this.categoria = categoria
        this.promotor = promotor
        this.classificacao = classificacao
        this.linhaProducao = linhaProducao
        this.cidades = cidades

        localStorage.setItem('supervisor', JSON.stringify(this.supervisor))
        localStorage.setItem('vendedor', JSON.stringify(this.vendedor))
        localStorage.setItem('area', JSON.stringify(this.area))
        localStorage.setItem('rede', JSON.stringify(this.rede))

        const empresaJson = JSON.stringify(this.select)
        localStorage.setItem('empresaId', empresaJson)

        this.showFaturamentoPrincipaisClientes()
      },

      async showFaturamentoPrincipaisClientes () {
        this.loading = true

        this.faturamentoPrincipaisClientes = []

        await Cliente.showFatPrincipaisClientesLitros(this.primeiroDia, this.date, this.select, this.supervisor, this.area, this.rede, this.vendedor, this.receita, localStorage.tokencontrato, this.segmento, this.categoria, this.promotor, this.classificacao, this.linhaProducao, this.cidades).then(resposta => {
          if (resposta.data.status) {
            this.faturamentoPrincipaisClientes = resposta.data.faturamento.map((item) => {
              var listaFaturamento = ({
                nome_cliente: item.nome_cliente,
                quantidade: item.quantidade.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                faturamento: parseFloat(item.faturamento).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
              })

              return listaFaturamento
            })
          } else if (resposta.data.msg === 'Não há faturamento para o período selecionado') {
            this.faturamentoPrincipaisClientes = []
            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loading = false })
      },
    },
  }
</script>

<style scoped>
  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
    @-moz-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-webkit-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-o-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)
  }

  #idTable {
    overflow-x: auto;
    overflow-y: auto;
    max-height: 600px;
  }

  #dadoMovimentacao {
    font-size: 12px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-family: Roboto, sans-serif;
    border: 1px solid #e0e0e0;
  }

  thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: #f5f5f5;
  }

  th, td {
    border: 1px solid #e0e0e0;
    padding: 10px;
    color: #424242;
  }

  thead {
    background-color: #f5f5f5;
  }

  tbody tr:hover {
    background-color: #f0f0f0;
  }

  #dadoMovimentacaoHeader {
    font-size: 12px !important;
    font-weight: 800 !important;
  }

  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 680px) {
    #headersPrincipaisClientes {
      font-size: 10px;
      max-width: 100%;
    }

    #idTable {
      max-height: 500px;
    }

    #dadoMovimentacao {
      font-size: 8.5px !important;
    }

    th, td {
      padding: 8px;
    }
  }

  @media screen
  and (min-width : 681px)
  and (max-width : 960px)
  and (-webkit-min-device-pixel-ratio: 1) {
    #principaisClientes {
      width: 100%;
    }

    #headersPrincipaisClientes {
      font-size: 10px;
    }
  }
</style>
